import { useEffect, useRef } from 'react'

import { UseFormReset } from 'react-hook-form'

import { Offer } from 'src/Redux/api/offersApi'

import { GetTotalRentOptions } from './useCalculator'
import { ModelCalculated } from './useCalculator'
import {
  transformOfferToFormData,
  transformOfferModelsToModelCalculated,
  OfferFormData,
} from './helpers'

/**
 * Хук для предварительного заполнения формы данными из существующего предложения
 * Автоматически заполняет форму и список оборудования при загрузке данных предложения
 */

interface UseOfferPreFillProps {
  offerData: Offer | undefined
  reset: UseFormReset<OfferFormData>
  getTotalRent: (options: GetTotalRentOptions) => number
  medicalExaminationCost: number
  setItems: (items: ModelCalculated[]) => void
  setInitialValues: (
    formData: OfferFormData,
    itemsData: ModelCalculated[],
  ) => void
}

export const useOfferPreFill = ({
  offerData,
  reset,
  getTotalRent,
  medicalExaminationCost,
  setItems,
  setInitialValues,
}: UseOfferPreFillProps): void => {
  // Используем ref для отслеживания уже обработанного offerId
  const processedOfferIdRef = useRef<number | null>(null)

  // Предварительное заполнение формы при загрузке данных предложения
  useEffect(() => {
    if (offerData && offerData.id !== processedOfferIdRef.current) {
      // Помечаем этот offer как обработанный
      processedOfferIdRef.current = offerData.id

      const offer = offerData
      const initialFormData = transformOfferToFormData(offer)

      reset(initialFormData)

      // Предварительное заполнение элементов моделей, если они доступны
      if (offer.offerModels && offer.offerModels.length > 0) {
        const modelItems = transformOfferModelsToModelCalculated(
          offer.offerModels,
          getTotalRent,
          offer,
          Number(medicalExaminationCost) || 0,
        )
        setItems(modelItems)

        // Установка начальных значений для отслеживания изменений
        setInitialValues(initialFormData, modelItems)
      } else {
        // Установка начальных значений для отслеживания изменений (без моделей)
        setInitialValues(initialFormData, [])
      }
    }
  }, [
    offerData,
    reset,
    getTotalRent,
    medicalExaminationCost,
    setItems,
    setInitialValues,
  ])
}
